import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useBlocks, useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";
import * as appConfig from "appConfig";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";

interface Introduction {
  title: string;
}

export const Introduction: React.FC<Introduction> = ({ title }) => {
  const ui = useUi();
  const blocks = useBlocks();
  const { formatMessage } = useIntl();

  const leftComponent = (
    <div className={styles.about}>
      <ui.Scrollbars>
        <p className={styles.description}>{formatMessage(messages.theoryDescription)}</p>
        <div className={styles.link}>
          <ui.Button
            size="small"
            shape={"normal"}
            theme={"primary"}
            onClick={() => window.open("https://github.com/AppliedAcousticsChalmers/ambisonic-microphone-arrays")}
          >
            {formatMessage(messages.githubLinkName)}
          </ui.Button>
        </div>
      </ui.Scrollbars>
    </div>
  );

  return (
    <StandardCase title={title} leftComponent={leftComponent}>
      <div className={styles.gallery}>
        <blocks.video src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide05/video.mp4`} />
      </div>
    </StandardCase>
  );
};
